import React, { useState, useMemo } from "react";
import { Dropdown, Menu } from "antd";

import { ChevronDownIcon } from "../../../../../resource/icons";
import {
	answerTypeIcons,
	answerTypes,
	answerTypeTexts,
	defaultAnswerType,
} from "../../../constants/answerType";

const getMenu = (setFieldsValue, questionId) => {
	const menu = [];
	const lastItem = answerTypes.length - 1;
	for (let index = 0; index <= lastItem; index++) {
		const Icon = answerTypeIcons[answerTypes[index]];

		menu.push(
			<Menu.Item
				className="NewVoting_question_dropdown_item"
				key={`item-${index}`}
				onClick={() =>
					setFieldsValue({
						[`questions[${questionId}].answerType`]: answerTypes[index],
					})
				}
			>
				<span>{answerTypeTexts[answerTypes[index]]}</span>
				<span className="NewVoting_question_dropdown_item-icon">
					<Icon />
				</span>
			</Menu.Item>
		);
		if (index < lastItem) {
			menu.push(<Menu.Divider key={`divider-${index}`} />);
		}
	}
	return (
		<Menu selectable mode="vertical">
			{menu}
		</Menu>
	);
};

const QuestionTypeDropdown = (props) => {
	const {
		questionId,
		form: { getFieldDecorator, setFieldsValue, getFieldValue },
	} = props;
	const [dropdownOpened, setDropdownOpened] = useState();
	const activeAnswerType =
		getFieldValue(`questions[${questionId}].answerType`) || defaultAnswerType;
	const menu = useMemo(() => getMenu(setFieldsValue, questionId));

	return (
		<>
			{getFieldDecorator(`questions[${questionId}].answerType`, {
				initialValue: defaultAnswerType,
			})(
				<Dropdown
					overlay={menu}
					trigger={["click"]}
					onVisibleChange={setDropdownOpened}
					placement="bottomRight"
				>
					<span className="NewVoting_question_dropdown_header">
						<span>{answerTypeTexts[activeAnswerType]}</span>
						<span className="NewVoting_question_dropdown_icon">
							<ChevronDownIcon
								className={
									dropdownOpened
										? `NewVoting_question_dropdown_icon-opened`
										: ""
								}
							/>
						</span>
					</span>
				</Dropdown>
			)}
		</>
	);
};

export default QuestionTypeDropdown;
